// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Checkbox */

.zTUTQyf4NCdc828n4c8G {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	height: 100%;
	cursor: pointer;
	-webkit-user-select: none;
	   -moz-user-select: none;
	        user-select: none;
	gap: 10px;
}

.zTUTQyf4NCdc828n4c8G > input {
	display: none;
}

.Xt2_1pUZxilSrrjg7D57 {
	color: #1D1D1B;
	font-size: 1.1em;
}

.UkY5v5UFeOeXSrZNNxmZ {
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	border: 1px solid #5EBED6;
	background-color: #BED4DB;
	width: 20px;
	height: 20px;
	aspect-ratio: 1/1;
}

.zTUTQyf4NCdc828n4c8G > input[type="radio"] ~ .UkY5v5UFeOeXSrZNNxmZ {
	border-radius: 50%;
}

.zTUTQyf4NCdc828n4c8G:hover > .UkY5v5UFeOeXSrZNNxmZ {
	background-color: #5EBED65F;
}

.UkY5v5UFeOeXSrZNNxmZ::before {
	content: "";
	position: absolute;
	top: 0;
	width: 35%;
    height: 70%;
    border: solid #1D1D1B;
    border-width: 0 2px 2px 0;
    transform: rotate( 45deg);
	scale: 0;
	opacity: 0;
	transition: scale 0.1s, opacity 0.1s;
}

.zTUTQyf4NCdc828n4c8G > input[type="radio"] ~ .UkY5v5UFeOeXSrZNNxmZ::before {
	border-width: 0;
	border-radius: inherit;
	top: unset;
	transform: unset;
	width: 70%;
	height: 70%;
	background-color: #1D1D1B;
}

.zTUTQyf4NCdc828n4c8G > input:checked ~ .UkY5v5UFeOeXSrZNNxmZ {
	background-color: #5EBED65F;
}

.zTUTQyf4NCdc828n4c8G > input:checked ~ .UkY5v5UFeOeXSrZNNxmZ::before {
	scale: 1;
	opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/Checkbox/style.module.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,yBAAiB;IAAjB,sBAAiB;SAAjB,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,UAAU;IACP,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;CAC5B,QAAQ;CACR,UAAU;CACV,oCAAoC;AACrC;;AAEA;CACC,eAAe;CACf,sBAAsB;CACtB,UAAU;CACV,gBAAgB;CAChB,UAAU;CACV,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,QAAQ;CACR,UAAU;AACX","sourcesContent":["/* Checkbox */\r\n\r\n.container {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: flex-start;\r\n\talign-items: center;\r\n\theight: 100%;\r\n\tcursor: pointer;\r\n\tuser-select: none;\r\n\tgap: 10px;\r\n}\r\n\r\n.container > input {\r\n\tdisplay: none;\r\n}\r\n\r\n.text {\r\n\tcolor: #1D1D1B;\r\n\tfont-size: 1.1em;\r\n}\r\n\r\n.indicator {\r\n\tdisplay: flex;\r\n\tposition: relative;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tborder: 1px solid #5EBED6;\r\n\tbackground-color: #BED4DB;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\taspect-ratio: 1/1;\r\n}\r\n\r\n.container > input[type=\"radio\"] ~ .indicator {\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.container:hover > .indicator {\r\n\tbackground-color: #5EBED65F;\r\n}\r\n\r\n.indicator::before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\twidth: 35%;\r\n    height: 70%;\r\n    border: solid #1D1D1B;\r\n    border-width: 0 2px 2px 0;\r\n    transform: rotate( 45deg);\r\n\tscale: 0;\r\n\topacity: 0;\r\n\ttransition: scale 0.1s, opacity 0.1s;\r\n}\r\n\r\n.container > input[type=\"radio\"] ~ .indicator::before {\r\n\tborder-width: 0;\r\n\tborder-radius: inherit;\r\n\ttop: unset;\r\n\ttransform: unset;\r\n\twidth: 70%;\r\n\theight: 70%;\r\n\tbackground-color: #1D1D1B;\r\n}\r\n\r\n.container > input:checked ~ .indicator {\r\n\tbackground-color: #5EBED65F;\r\n}\r\n\r\n.container > input:checked ~ .indicator::before {\r\n\tscale: 1;\r\n\topacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zTUTQyf4NCdc828n4c8G`,
	"text": `Xt2_1pUZxilSrrjg7D57`,
	"indicator": `UkY5v5UFeOeXSrZNNxmZ`
};
export default ___CSS_LOADER_EXPORT___;
